import Pop from 'components/Popover/Pop';
import Text from 'components/Text/Text';
import { useLoggedUserRestaurants } from 'hooks/useLoggedUserRestaurants';
import React from 'react';
import style from './PositionsList.module.scss';

interface IPositionsListRestaurant {
	id: string;
	restaurantName: string | null;
	positionNumber: number;
}

interface IPositionsList {
	restaurants: IPositionsListRestaurant[];
}

const PositionsList: React.FC<IPositionsList> = ({ restaurants }) => {
	const accessibleRestaurants = useLoggedUserRestaurants(restaurants);

	const RestaurantsPositionContent = () => {
		return (
			<div className={style.container} data-test="RestaurantsPositionContent">
				{accessibleRestaurants.map((el) => (
					<div className={style.item} key={el.id}>
						<Text
							className={style.positionNumber}
							translationKey={`(${el.positionNumber}) `}
							theme="secondary"
							size="xs"
							display="inline"
						/>
						<Text translationKey={el.restaurantName} size="xs" display="inline" />
					</div>
				))}
			</div>
		);
	};

	return (
		<div data-test="RestaurantsPositionList">
			{accessibleRestaurants.length > 1 ? (
				<Pop placement="bottomLeft" content={<RestaurantsPositionContent />} trigger="click">
					<div className={style.wrapper}>
						<Text
							translationNameSpace="listing"
							translationKey="positionValue"
							components={[<span key="1" className={style.positionNumber} />]}
							values={{
								positionNumber: accessibleRestaurants[0].positionNumber,
								restaurantName: accessibleRestaurants[0].restaurantName,
							}}
							withTooltip={true}
							data-test="RestaurantsPosition"
						/>
						<span className={style.showListBtn}>&middot;&middot;&middot;</span>
					</div>
				</Pop>
			) : (
				<>
					{accessibleRestaurants.length ? (
						<Text
							translationNameSpace="listing"
							translationKey="positionValue"
							components={[<span key="1" className={style.positionNumber} />]}
							values={{
								positionNumber: accessibleRestaurants[0].positionNumber,
								restaurantName: accessibleRestaurants[0].restaurantName,
							}}
							withTooltip={true}
						/>
					) : (
						'-'
					)}
				</>
			)}
		</div>
	);
};

export default React.memo(PositionsList);
